import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/usePageTitle";
import { hasRetainedData } from "@/lib/api/retainedAttempt";
import { leaveGuardActive } from "@/lib/leaveGuards";

export function NotFound({ inShell = false }: { inShell?: boolean }) {
  const { t } = useTranslation();
  usePageTitle(t("notFound.title"));
  return (
    <div
      className={inShell ? "py-20 text-center" : "grid min-h-dvh place-items-center bg-bg px-6 text-center"}
    >
      <div className="space-y-5">
        <p className="bg-gradient-to-b from-fg to-fg-subtle bg-clip-text text-[7rem] leading-none font-semibold tracking-tighter text-transparent sm:text-[9rem]">
          404
        </p>
        <div className="space-y-2">
          <h1 className="text-title-lg font-semibold">{t("notFound.title")}</h1>
          <p className="text-body-lg text-fg-muted">{t("notFound.body")}</p>
        </div>
        <Button asChild size="lg">
          <Link to={inShell ? "/app" : "/"}>{t("notFound.home")}</Link>
        </Button>
      </div>
    </div>
  );
}

export function RouteError({ reset }: { reset?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[60vh] place-items-center px-6 text-center">
      <div className="space-y-4">
        <p className="text-title-lg font-semibold">{t("errors.boundary")}</p>
        <Button
          onClick={() => {
            // Retained creates (generated passwords, idempotency keys) live
            // only in this tab's memory: say what a reload would lose.
            if ((hasRetainedData() || leaveGuardActive()) && !window.confirm(t("errors.reloadLoses"))) return;
            reset?.();
            window.location.reload();
          }}
        >
          {t("errors.boundaryAction")}
        </Button>
      </div>
    </div>
  );
}
